import { getStateFromPath } from '@react-navigation/native';

type ResolvedState = NonNullable<ReturnType<typeof getStateFromPath>>;
type ResolvedRoute = ResolvedState['routes'][number];

const aiHome = (): ResolvedRoute => ({
  name: 'Main',
  state: {
    routes: [{ name: 'Tabs', state: { routes: [{ name: 'AiHome' }] } }],
  },
});

/** The pages a deep-linked AI page sits on, AI home excluded. */
function pagesBeneath(route: ResolvedRoute): ResolvedRoute[] | null {
  switch (route.name) {
    case 'AiChat':
    case 'PosterStudio':
    case 'BiHome':
    case 'BiDashboards':
    case 'BiDashboard':
    case 'BiDatasets':
    case 'BiExports':
      return [];
    case 'BiDashboardCard': {
      const { dashboardId } = (route.params ?? {}) as { dashboardId?: string };
      return [{ name: 'BiDashboard', params: { dashboardId } }];
    }
    case 'BiDataset':
      return [{ name: 'BiDatasets', params: {} }];
    default:
      return null;
  }
}

/**
 * Builds the history an AI page the app starts on (a cold start, a web
 * reload, the page requested before login) would have had if reached by
 * hand — AI home at the bottom, then the page's parents — so every back on
 * these pages is a plain `goBack()`. A link opened in the running app
 * pushes the page alone instead (`openOnTop`).
 */
export function withAiHistory(
  state: ResolvedState | undefined,
): ResolvedState | undefined {
  if (state?.routes.length !== 1) return state;
  const [route] = state.routes;
  const beneath = pagesBeneath(route);
  if (!beneath) return state;
  const routes = [aiHome(), ...beneath, route];
  return { ...state, routes, index: routes.length - 1 };
}
